document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-load-more]');
  if (!button || button.disabled) return;

  const section = button.closest('.shopify-section');
  const grid = section?.querySelector('.product-grid');

  if (!grid) return;

  button.disabled = true;
  button.textContent = 'Wird geladen...';

  try {
    const page = Number(button.dataset.nextPage);
    const sectionId = button.dataset.sectionId;

    const url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', sectionId);

    const response = await fetch(url.toString());
    if (!response.ok) throw new Error('Loading failed');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = doc.querySelector('.product-grid');

    if (!newGrid) throw new Error('Product grid not found');

    const newItems = [...newGrid.querySelectorAll(':scope > .grid__item')];

    if (newItems.length === 0) {
      button.remove();
      return;
    }

    grid.append(...newItems);
    button.dataset.nextPage = String(page + 1);

    if (newItems.length < 12) {
      button.remove();
    } else {
      button.textContent = 'Mehr laden';
      button.disabled = false;
    }
  } catch (error) {
    console.error('Mehr laden:', error);
    button.textContent = 'Erneut versuchen';
    button.disabled = false;
  }
});